import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { OrganizationProfileDto, UpdateOrganizationProfileRequestDto } from '../../dtos/organization-profile.dto';

@Injectable()
export class OrganizationProfileRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public get(organizationId: number): Observable<OrganizationProfileDto> {
    return this.http.get<OrganizationProfileDto>(`${this.apiUrl}${API_ENDPOINTS.organizationProfile.get(organizationId)}`);
  }

  public update(organizationId: number, payload: UpdateOrganizationProfileRequestDto): Observable<OrganizationProfileDto> {
    return this.http.put<OrganizationProfileDto>(
      `${this.apiUrl}${API_ENDPOINTS.organizationProfile.get(organizationId)}`,
      payload,
    );
  }

  public updateLogo(organizationId: number, file: File): Observable<OrganizationProfileDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put<OrganizationProfileDto>(
      `${this.apiUrl}${API_ENDPOINTS.organizationProfile.logo(organizationId)}`,
      formData,
    );
  }
}
